import { injectIntl } from 'react-intl';
import type { IntlShape } from 'react-intl';

import { BreadcrumbsItem } from '@atlaskit/breadcrumbs';

import { ComponentLink as Link } from 'src/components/component-link';
import { useAnalytics } from 'src/components/settings/analytics';
import RepositoryBreadcrumbs from 'src/sections/repository/containers/breadcrumbs';

import { messages } from './breadcrumbs.i18n';
import { BreadcrumbItemStyled } from './settings.styled';

type RepoAdminBreadcrumbsProps = {
  settingsHref: string;
  intl: IntlShape;
};

const RepoAdminBreadcrumbs = ({
  intl,
  settingsHref,
}: RepoAdminBreadcrumbsProps) => {
  const text = intl.formatMessage(messages.admin);
  const { publishBreadcrumbClickEvent } = useAnalytics();

  return (
    <RepositoryBreadcrumbs>
      <BreadcrumbItemStyled>
        <BreadcrumbsItem
          href={settingsHref}
          text={text}
          component={Link}
          onClick={() => publishBreadcrumbClickEvent('SettingsLink')}
        />
      </BreadcrumbItemStyled>
    </RepositoryBreadcrumbs>
  );
};

// eslint-disable-next-line import/no-default-export
export default injectIntl(RepoAdminBreadcrumbs);
